import {LOAD_REQUEST, FINISH_REQUEST} from '../constants/constants'

export const doLoad = () =>({
    type : LOAD_REQUEST
})

export const finishLoad = () =>({
    type : FINISH_REQUEST
})

window.doLoad = doLoad;
window.finishLoad = finishLoad;


// WEBPACK FOOTER //
// ./src/actions/request.js